import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchPayers() {
  const { oktaAuth } = useOktaAuth();
  const dataKey = "useFetchPayersResultKey";

  async function getPayers() {
    const accessToken = await oktaAuth.getAccessToken();
    const oktaUser = await oktaAuth.getUser();

    try {
      const payerResponse = await axios.get(`api/UserProgram/GetAllPayers`, {
        params: { email: oktaUser.email },
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (!payerResponse.data) {
        return [];
      }

      let PayerList = Object.keys(payerResponse.data).map((key) => {
        return {
          label: payerResponse.data[key],
          value: key,
        };
      });

      return PayerList.sort((p1, p2) =>
        p1.label > p2.label ? 1 : p1.label < p2.label ? -1 : 0
      );
    } catch (error) {
      throw new Error(error);
    }
  }

  return useQuery({
    queryKey: [dataKey],
    queryFn: async () => await getPayers(),
  });
}
